import React from 'react';
import { Login } from '../../components/Login';

export const LoginPage: React.FC = () => {
    return <Login />;
};
